import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    marginTop: theme.spacing(10),
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginTop: theme.spacing(0.5),
    fontSize: 20,
    textAlign: 'start',
    color: 'black',
  },
  buttonBox: {
    // justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    width: '30%',
    minWidth: 500,
  },
  greyBtn: {
    width: '30%',
    marginRight: theme.spacing(1),
    boxShadow: 'none',
    textTransform: 'none',
  },
  actionBtn: {
    width: '45%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  text: {
    //margin: '0 0 24px',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
    fontSize: 15,
    color: 'black',
  },
}));
